import React from "react"

import { TabBarBaseRoot } from "./TabBarBaseRoot"
import { TabBarSortableRoot } from "./TabBarSortableRoot"

export interface TabBarRootProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "onSelect"> {
  activeKey: string
  onSelect?: (eventKey: string) => void
  children: React.ReactNode
  enableSort?: boolean
  onSort?: (eventKey: string, oldIndex: number, newIndex: number) => void
}

export const TabBarRoot = React.memo(
  ({ enableSort, ...props }: TabBarRootProps) => {
    if (enableSort) return <TabBarSortableRoot enableSort {...props} />
    return <TabBarBaseRoot {...props} />
  }
)

TabBarRoot.displayName = "TabBar.Root"
